import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({ name: 'getAssetsPath' })
export class getAssetsPath implements PipeTransform {
  transform(variable: string): any {
    return `${environment.assetsPath}/${variable}`;
  }
}
